export default "__VITE_PUBLIC_ASSET__4914ce8b__"